import { Map as ImmutableMap } from 'immutable';
import pick from 'transmute/pick';
import omit from 'transmute/omit';
import { EXCLUDED_FORM_FIELDS } from 'MeetingsLib/constants/enums';
export const TRACKING_PARAM_KEYS = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content', 'meeting_funnel', 'meeting_product', 'meeting_medium', 'meeting_type', 'meeting_source', 'meeting_campaign', 'meeting_thread', 'source_app', 'hubs_signup-url', 'hubs_signup-cta', 'hubs_content', 'hubs_content-cta', 'hubs_offer', 'hubs_post', 'hubs_post-cta', 'ab', 'abStatus', 'contentId', 'referrer'];
export const PARENT_PAGE_PARAM_KEYS = ['parentPageUrl', 'parentHubspotUtk'];
export const getTrackingParams = urlParams => pick(TRACKING_PARAM_KEYS, urlParams);

// Everything that is not a tracking or parent page param is a form field prefill candidate.
export const getFormFieldUrlParams = urlParams => omit([...TRACKING_PARAM_KEYS, ...PARENT_PAGE_PARAM_KEYS], urlParams);
export const mapFalsyParamsToNull = url => {
  const queryParams = new URLSearchParams(url.search);
  const params = Object.fromEntries(queryParams);
  return Object.keys(params).reduce((acc, key) => Object.assign({}, acc, {
    [key]: params[key] || null
  }), {});
};
export const constructFormState = formFieldUrlParams => {
  let firstName;
  let lastName;
  let email;
  const paramsAsMap = ImmutableMap(formFieldUrlParams);
  const customFormFields = paramsAsMap.reduce((acc, val, originalKey) => {
    const key = originalKey.toLowerCase();
    if (key === 'firstname') {
      firstName = val;
    } else if (key === 'lastname') {
      lastName = val;
    } else if (key === 'email') {
      email = val;
    } else if (EXCLUDED_FORM_FIELDS.indexOf(key) === -1) {
      acc[originalKey] = val;
    }
    return acc;
  }, {});
  return {
    firstName,
    lastName,
    email,
    customFormFields
  };
};